/* eslint-disable max-lines */

export const config = {
    name: 'assetHandover-fullBusiness',
    selection: true,
    index: false,
    searchFields: [
        {
            name: '商机大类',
            value: 'opportunityCategoryList',
            type: 'select',
            isFixed: true,
            multiple: true,
            optionNum: 'NEOCRM_BUSINESS_TYPE',
            span: 5
        },
        {
            name: '业务类型',
            value: 'businessTypeList',
            type: 'select',
            isFixed: true,
            multiple: true,
            optionNum: 'NEOCRM_BUSINESS_CATEGORY',
            span: 5
        },
        {
            name: '客户等级',
            value: 'customerLevelList',
            type: 'select',
            isFixed: true,
            multiple: true,
            optionNum: 'NEOCRM_CUSTOMER_LEVEL',
            span: 5
        },
        {
            name: '行业大类',
            value: 'industryCategoryList',
            type: 'select',
            options: [],
            isFixed: true,
            multiple: true,
            span: 5
        },
        {
            name: '行业类型',
            value: 'industryTypeName',
            type: 'advanceMulti',
            isFixed: true,
            span: 5,
            advanceConfig: [
                { 'prop': 'industryTypeName', 'value': '行业类型名称' },
                { 'prop': 'industryTypeCode', 'value': '行业类型编码' }
            ],
            tableConfig: [
                { 'prop': 'industryTypeCode', 'value': '行业类型编码' },
                { 'prop': 'industryTypeName', 'value': '行业类型名称', 'displayName': 'industryTypeName' }
            ],
            prefix: '/api-lcrm',
            advanceUrl: `/industry/info/page`,
            method: 'post',
            cbParams: ['industryTypeCode', 'industryTypeName']
        }
    ],
    columns: [
        {
            label: '单据编码',
            prop: 'documentNo',
            width: 120
        },
        {
            label: '客户名称',
            prop: 'customerName',
            width: 200
        },
        {
            label: '客户仓库',
            prop: 'customerWarehouse',
            width: 150
        },
        {
            label: '商机大类',
            prop: 'opportunityCategory',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'NEOCRM_BUSINESS_TYPE'
        },
        {
            label: '业务类别',
            width: 150,
            prop: 'businessType',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'NEOCRM_BUSINESS_CATEGORY'
        },
        {
            label: '始发仓',
            width: 120,
            prop: 'warehouseType',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'NEOCRM_WH_TYPE'
        },
        {
            label: '窗口期',
            width: 160,
            prop: 'windowPeriod'
        },
        {
            label: '分公司',
            width: 150,
            prop: 'branchCompany'
        },
        {
            label: '客户系',
            width: 150,
            prop: 'customerSeriesName'
        },
        {
            label: '客户等级',
            width: 150,
            prop: 'customerLevel',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'NEOCRM_CUSTOMER_LEVEL'
        },
        {
            label: '行业大类',
            width: 150,
            prop: 'industryCategory',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'SYS_SUPPLIER_INDUSTRY'
        },
        {
            label: '行业类型',
            width: 150,
            prop: 'industryTypeName'
        },
        {
            label: '承接人',
            prop: 'receiverName',
            type: 'slot',
            slot: true,
            editSlot: true,
            width: 100,
            fixed: 'right'
        }
    ]
};
